<div class="auth__container">
  <div class="auth__component-container">
    <router-outlet></router-outlet>
  </div>
</div>
